
import CustomDrawer from './CustomDrawer.vue';
import CloseIcon from '../icons/CloseIcon.vue';
import SearchIcon from '../icons/SearchIcon.vue';
import { mapActions } from 'vuex';
import axios from 'axios';
import klipyPoweredLogo from '~/assets/img/powered-by-klipy-image.png';
import { debounce } from 'lodash';

export default {
  name: 'GifSelectorDrawer',
  components: { CustomDrawer, CloseIcon, SearchIcon },
  props: {
    // show: {
    //   type: Boolean,
    //   required: true,
    // },
  },

  data() {
    return {
      searchText: '',
      loading: false,
      result: [],
      col1: [],
      col2: [],
      apiKey: process.env.NUXT_ENV_KLIPY_API_KEY,
      apiUrl: process.env.NUXT_ENV_KLIPY_API_URL,
      klipyPoweredLogo: klipyPoweredLogo.default || klipyPoweredLogo,
      animationDurationMs: 100,
      show: false,
    };
  },
  mounted() {
    this.show = true;
    this.init();
  },

  methods: {
    ...mapActions('modals', ['setKlipyLastTrendingSearch']),
    performSearch: debounce(function () {
      this.searchGifs(this.searchText ? 'search' : 'trending');
    }, 400),
    async searchGifs(action = 'search') {
      if (action === 'search') {
        this.loading = true;
      }

      try {
        const endpoint =
          action === 'trending'
            ? `${this.apiUrl}/${this.apiKey}/gifs/trending`
            : `${this.apiUrl}/${this.apiKey}/gifs/search`;

        const params =
          action === 'search'
            ? { q: this.searchText, limit: 30 }
            : { page: 1, per_page: 30, customer_id: '12346', locale: 'en-US' };

        const response = await axios.get(endpoint, { params });
        const gifs = response.data?.data?.data ?? [];

        const mapped = gifs
          .map((gif) => ({
            id: gif.id,
            url:
              gif.file?.sm?.gif?.url ||
              gif.file?.md?.gif?.url ||
              gif.file?.xs?.gif?.url,
          }))
          .filter(Boolean);

        this.result = mapped;
        this.distributeIntoColumns(mapped);
      } catch (e) {
        console.error('Klipy search error:', e);
      } finally {
        this.loading = false;
      }
    },

    distributeIntoColumns(items) {
      this.col1 = [];
      this.col2 = [];

      items.forEach((item, index) => {
        (index % 2 === 0 ? this.col1 : this.col2).push(item);
      });
    },

    onClickImage(image, id, uri) {
      this.$emit('onGifSelected', {
        src: image.srcElement.currentSrc,
        id,
        uri,
      });
      this.handleCloseDrawer();
    },

    handleCloseDrawer() {
      this.show = false;
      setTimeout(() => {
        this.$emit('close');
      }, 200);
    },
    focusSearchInput() {
      const comp = this.$refs.gifSelectorDrawerSearchInput;
      // FormulateInput is a component, so getting the real input
      const el = comp?.$el?.querySelector(
        'input, textarea, [contenteditable="true"]'
      );
      el?.focus();
    },
    async init() {
      this.loading = true;
      this.searchGifs('trending').then(() => {
        this.setKlipyLastTrendingSearch();
        setTimeout(() => {
          this.focusSearchInput();
        }, this.animationDurationMs);
      });
    },
  },
};
